const shared = require('./shared'),
    accessReview = require('./accessReview'),
    afe = require('./afe'),
    changePassword = require('./changePassword'),
    contact = require('./contact'),
    docApproval = require('./docApproval'),
    docApprovalSearch = require('./docApprovalSearch'),
    entry = require('./entry'),
    entryAudit = require('./entryAudit'),
    entryTypeAccess = require('./entryTypeAccess'),
    help = require('./help'),
    login = require('./login'),
    myAccount = require('./myAccount'),
    notification = require('./notification'),
    passwordReset = require('./passwordReset'),
    prodData = require('./prodData'),
    recycleBin = require('./recycleBin'),
    report = require('./report'),
    requestAccess = require('./report'),
    role = require('./role'),
    search = require('./search'),
    well = require('./well'),
    wellUser = require('./wellUser'),
    maintSummary = require('./maintSummary'),
    wellGroup = require('./wellGroup'),
    wellUserHistory = require('./wellUserHistory');

module.exports = _.extend(
    shared,
    accessReview,
    afe,
    changePassword,
    contact,
    docApproval,
    docApprovalSearch,
    entry,
    entryAudit,
    entryTypeAccess,
    help,
    login,
    myAccount,
    notification,
    passwordReset,
    prodData,
    recycleBin,
    report,
    requestAccess,
    role,
    search,
    well,
    wellUser,
    wellGroup,
    wellUserHistory,
    maintSummary,
);
